import i18next from "i18next";

export const validationMessages = {
  required: "required",
  alpha_num_dash_space: "alpha_num_dash_space",
  phone: "phone",
  numeric: "numeric",
  email: "email",
  max_lenght: "max_lenght",
  min_length: "min_length"
};

export const validateField = (value, rules) => {
  if (!rules) return "";

  const safeValue =
    value === null || value === undefined ? "" : String(value);

  if (safeValue === "" && !rules.includes("required")) return "";

  for (const rule of rules) {
    if (typeof rule === "string") {
      if (
        rule === "required" &&
        (Array.isArray(value) ? value.length === 0 : !safeValue)
      ) {
        return i18next.t(validationMessages[rule]);
      }

      if (
        rule === "alpha_num_dash_space" &&
        !/^[a-zA-Z0-9-\s]+$/.test(safeValue)
      ) {
        return i18next.t(validationMessages[rule]);
      }

      if (rule === "phone") {
        const phoneWithCountryCode = /^\+[0-9]{11,13}$/;
        const plainPhone = /^[0-9]{10}$/;
        const isValid =
          (safeValue.startsWith("+") && phoneWithCountryCode.test(safeValue)) ||
          (!safeValue.startsWith("+") && plainPhone.test(safeValue));

        if (!isValid) {
          return i18next.t(validationMessages[rule]);
        }
      }

      if (rule === "numeric" && !/^[0-9]+$/.test(safeValue)) {
        return i18next.t(validationMessages[rule]);
      }

      if (
        rule === "email" &&
        !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(safeValue)
      ) {
        return i18next.t(validationMessages[rule]);
      }
    }

    if (typeof rule === "object") {
      if (rule.max && safeValue.length > parseInt(rule.max)) {
        return i18next.t("max_length", { count: rule.max });
      }
      if (rule.min && safeValue.length < parseInt(rule.min)) {
        return i18next.t("min_length", { count: rule.min });
      }
    }
  }

  return "";
};